import { render, staticRenderFns } from "./NotEstimated.vue?vue&type=template&id=079b756f&"
import script from "./NotEstimated.vue?vue&type=script&lang=js&"
export * from "./NotEstimated.vue?vue&type=script&lang=js&"
import style0 from "./NotEstimated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports